import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-right"
      expand={false}
      duration={4000}
      gap={8}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white dark:group-[.toaster]:bg-slate-900 group-[.toaster]:text-slate-900 dark:group-[.toaster]:text-slate-100 group-[.toaster]:border group-[.toaster]:border-slate-200 dark:group-[.toaster]:border-slate-800 group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl group-[.toaster]:p-4 group-[.toaster]:gap-3",
          title: "group-[.toast]:text-sm group-[.toast]:font-semibold group-[.toast]:text-slate-900 dark:group-[.toast]:text-slate-100 group-[.toast]:leading-tight",
          description: "group-[.toast]:text-slate-600 dark:group-[.toast]:text-slate-400 group-[.toast]:text-xs sm:group-[.toast]:text-sm group-[.toast]:leading-relaxed group-[.toast]:mt-1",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:text-xs group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:rounded-md group-[.toast]:font-medium",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:text-xs group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:rounded-md",
          closeButton: "group-[.toast]:bg-transparent! group-[.toast]:border-none! group-[.toast]:text-slate-400 group-[.toast]:hover:text-slate-700 dark:group-[.toast]:hover:text-slate-200",
          success: "group-[.toaster]:border-emerald-200 dark:group-[.toaster]:border-emerald-800/60 **:data-icon:text-emerald-600!",
          error: "group-[.toaster]:border-rose-200 dark:group-[.toaster]:border-rose-800/60 **:data-icon:text-rose-600!",
          warning: "group-[.toaster]:border-amber-200 dark:group-[.toaster]:border-amber-800/60 **:data-icon:text-amber-600!",
          info: "group-[.toaster]:border-blue-200 dark:group-[.toaster]:border-blue-800/60 **:data-icon:text-blue-600!",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
